import React from 'react';
import { Modal, Button, Form, Table, Container } from 'react-bootstrap';
import { Perfil } from '../../../model/Usuario/Perfil';
import { PerfilViewModel } from '../../../viewmodel/usuario/PerfilViewModel';
import { toast } from 'react-toastify';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

interface CriarPerfilModalProps {
    show: boolean;
    handleClose: () => void;
    perfisDisponiveis: Perfil[];
    setPerfisDisponiveis: React.Dispatch<React.SetStateAction<Perfil[]>>;
}

const validationSchema = Yup.object({
    nome: Yup.string().required('Nome é obrigatório'),
    descricao: Yup.string().required('Descrição é obrigatória')
});

const CriarPerfilModal: React.FC<CriarPerfilModalProps> = ({ show, handleClose, perfisDisponiveis, setPerfisDisponiveis }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Criar Novo Perfil</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={{ nome: '', descricao: '' }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            const newPerfil: Perfil = {
                                nome: values.nome,
                                descricao: values.descricao,
                                permissoes: [] 
                            };

                            try {
                                const usuario = await PerfilViewModel.criarPerfil(newPerfil);
                                setPerfisDisponiveis([...perfisDisponiveis, usuario]); // Atualiza o estado
                                toast.success('Perfil criado com sucesso!'); // Toast de sucesso
                                handleClose(); // Fecha o modal após salvar
                            } catch (error) {
                                if (error instanceof Error) {
                                    toast.error(`Erro ao criar perfil: ${error.message}`); // Toast de erro com a mensagem
                                } else {
                                    toast.error('Erro desconhecido ao criar perfil'); // Toast de erro genérico
                                }
                            }
                            setSubmitting(false);
                        }}
                    >
                        {({ isSubmitting }) => (
                            <FormikForm>
                                <div className="mt-3">
                                    <h5>Perfis Disponíveis</h5>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {perfisDisponiveis.map((perfil, index) => (
                                                <tr key={index}>
                                                    <td>{perfil.nome}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                                <Container className="shadow-lg p-5 mb-1 bg-body rounded rounded-4">
                                    <Form.Group controlId="formPerfilNome">
                                        <Form.Label>Nome:</Form.Label>
                                        <Field name="nome" type="text" placeholder="Digite o nome do perfil" className="form-control" />
                                        <ErrorMessage name="nome" component="div" className="text-danger" />
                                    </Form.Group>
                                    <Form.Group controlId="formPerfilDescricao" className="mt-3">
                                        <Form.Label>Descrição:</Form.Label>
                                        <Field name="descricao" type="text" placeholder="Digite a descrição do perfil" className="form-control" />
                                        <ErrorMessage name="descricao" component="div" className="text-danger" />
                                    </Form.Group>
                                    <div className="mt-3 d-flex justify-content-center">
                                        <Button variant="success" type="submit" style={{ marginTop: '22px' }} disabled={isSubmitting}>
                                            Criar Perfil
                                        </Button>
                                    </div>
                                </Container>
                            </FormikForm>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CriarPerfilModal;
